import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Address } from './Address';
import { EmploymentGradeOptions, YearGroupOptions } from './SharedOptions';
import { Specialty } from './Specialty';
import {
  USERS_I_CAN_SEE_ADMIN,
  USERS_I_CAN_SEE_USER,
  USERS_I_CAN_UPDATE_ADMIN,
  USERS_I_CAN_UPDATE_USER,
} from './SecurityRules';

export interface PersonRow {
  id: number;
  first_name: string;
  last_name: string;
  date_of_birth: string;
  // employer: number;
  address_id: number;
  // education_id: number;
  occupation: string;
  phone_number: string;
  photo: string;
  specialty: string | null;
  employment_grade: string | null;
  year_group: string | null;
}

const PersonYearGroupOptions = YearGroupOptions.filter((option) => option.id !== 'all_years');

export const Person: Entity<PersonRow> = {
  id: 'Person',
  title: 'Person',
  service: 'main',
  rowLabel: (row: PersonRow) => [row.first_name, row.last_name].join(' '),
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.person',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: 'id IN (SELECT person_id FROM public.user_view WHERE id IN ' + USERS_I_CAN_SEE_USER + ')',
    },
    {
      role: 'user',
      action: 'all',
      access: 'conditional',
      condition: 'id IN (SELECT person_id FROM public.user_view WHERE id IN ' + USERS_I_CAN_UPDATE_USER + ')',
    },
    {
      role: 'admin',
      action: 'read',
      access: 'conditional',
      condition: 'id IN (SELECT person_id FROM public.user_view WHERE id IN ' + USERS_I_CAN_SEE_ADMIN + ')',
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: 'id IN (SELECT person_id FROM public.user_view WHERE id IN ' + USERS_I_CAN_UPDATE_ADMIN + ')',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['last_name', 'ASC']],
  defaultFilters: [{ fieldId: 'last_name', operator: 'sw', value: '' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
      visible: false,
    },
    first_name: {
      seq: 10,
      type: FieldType.Text,
      label: 'First Name',
      listColumn: true,
      mandatory: true,
      maxLength: 80,
    },
    last_name: {
      seq: 15,
      type: FieldType.Text,
      label: 'Last Name',
      listColumn: true,
      mandatory: true,
      maxLength: 80,
    },
    date_of_birth: {
      seq: 20,
      type: FieldType.Date,
      label: 'Date of Birth',
    },
    // TODO ref to what?
    // employer: {
    //   seq: 25,
    //   type: FieldType.Text,
    //   label: 'employer',
    // },
    // ref to address table - this isn't implemented
    address_id: {
      seq: 30,
      type: FieldType.Reference,
      label: 'Address',
      refEntity: Address,
      persistence: PersistenceType.BackEndOnly,
    },
    // ref to education table
    // education_id: {
    //   seq: 35,
    //   type: FieldType.Text,
    //   label: '',
    // },
    occupation: {
      seq: 40,
      type: FieldType.Text,
      label: 'Occupation',
      maxLength: 80,
    },
    phone_number: {
      seq: 45,
      type: FieldType.Text,
      label: 'Phone Number',
      maxLength: 20,
    },
    photo: {
      seq: 50,
      type: FieldType.Text,
      label: 'Photo',
      persistence: PersistenceType.BackEndManaged,
    },
    specialty: {
      seq: 55,
      label: 'Specialty',
      type: FieldType.Reference,
      refEntity: Specialty,
    },
    employment_grade: {
      seq: 60,
      type: FieldType.Options,
      label: 'Employment Grade',
      options: EmploymentGradeOptions.filter((option) => option.id !== '0'),
    },
    year_group: {
      seq: 65,
      type: FieldType.Options,
      label: 'Year Group',
      options: PersonYearGroupOptions,
    },
  },
};
